import { render, staticRenderFns } from "./BeforeJudgementWaiterListTab.vue?vue&type=template&id=6e6e4c4a&scoped=true&lang=pug"
import script from "./BeforeJudgementWaiterListTab.vue?vue&type=script&lang=ts"
export * from "./BeforeJudgementWaiterListTab.vue?vue&type=script&lang=ts"
import style0 from "./BeforeJudgementWaiterListTab.vue?vue&type=style&index=0&id=6e6e4c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e4c4a",
  null
  
)

export default component.exports